export const en = {
  'ui2-card-slideshow': {
    controls: {
      previous: 'Scroll left',
      next: 'Scroll right'
    }
  }
};
